import axiosAgsc from "@/store/axiosAgsc";
const resource = "/Computer";

export default {
  get: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetComputerList`, payload);
  },
  getComputerDetail: (computerGuid: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetComputerDetail`, {
      params: { computerGuid },
    });
  },
  getComputerByGroups: (payload: any = {}): any => {
    return axiosAgsc.post(`${resource}/GetGroupComputersFromEs`, payload);
  },
  searchComputer: (keyword: any = {}, site: any, groups: any): any => {
    let query = `?keyword=${keyword}`;
    if(site) {
      query = query + `&site=${site}`;
    }
    if(groups && groups.length > 0) {
      groups.forEach((element: any) => {
        query = query + `&group=${element}`;
      });
    }
    return axiosAgsc.get(`${resource}/SearchComputer${query}`,[]);
  },
  getActiveOrOffileneComputers: (payload: any = {}): any => {
    return axiosAgsc.post(`${resource}/GetActiveOrOffileneComputers`, payload);
  },
  getComputerUserList: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetComputerUserList?computerGuid=${payload}`, []);
  },
  getAgscComputerList: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetAgscComputerList`, []);
  },
};
